// extracted by mini-css-extract-plugin
module.exports = {"item":"_1o7wJ","wrapper":"_3-w3M","iframe":"_27lVq","content":"Fmi7K","itemTitle":"_3Esam","footer":"_3pfk6","date":"_2ZDHh"};